module.exports = {"id":"165769","name":"Cássio","rating":"76","photo":"./data/images/photos/4/165769.png","club":{"name":"Rio Ave","logo":"./data/images/clubs/RioAve.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Cassio0.json
// module id = 737
// module chunks = 0